/* claude- (2026-09-11, Adam: "I want the images to swipe on and off the
   screen, no border, and fade in and out so it isn't so harsh") — a
   crossfade for the two product photo strips: the glass product page's
   .c3d-ovl__pdp-track and the product page's .media-viewer. Each photo's
   opacity follows its distance from the strip's centre (smoothstep), so
   the leaving photo dims as the arriving one brightens. Only while the
   strip actually scrolls sideways: the desktop product page stacks its
   photos in a grid and is left alone. Scroll is caught in the capture
   phase on document, so the glass strip (built after a tap) needs no
   registration. */
(function () {
  'use strict';
  var SEL = '.c3d-ovl__pdp-track, .media-viewer';
  function paint(el) {
    var kids = el.children, n = kids.length, i, k, w, d, o;
    if (el.scrollWidth <= el.clientWidth + 1) {
      if (el.__fadeOn) { for (i = 0; i < n; i++) kids[i].style.opacity = ''; }
      el.__fadeOn = false;
      return;
    }
    el.__fadeOn = true;
    /* claude- (2026-10-03, Adam: "on desktop the product picture in the popup
       card does not show") — measure each photo against the strip itself.
       offsetLeft counts from the nearest positioned ancestor, which on the
       desktop two-column glass popup is the whole popup, not the strip, so
       the photo in view was faded to 0 and an off-screen copy to 1. On phones
       the two happened to line up. Screen rects are always the same frame. */
    var er = el.getBoundingClientRect();
    var mid = er.left + el.clientWidth / 2;
    for (i = 0; i < n; i++) {
      k = kids[i]; w = k.offsetWidth; if (!w) continue;
      var kr = k.getBoundingClientRect();
      d = Math.min(1, Math.abs(kr.left + kr.width / 2 - mid) / w);
      o = 1 - d;
      k.style.opacity = (o * o * (3 - 2 * o)).toFixed(3);
    }
  }
  function schedule(el) {
    if (el.__fadeRaf) return;
    el.__fadeRaf = requestAnimationFrame(function () { el.__fadeRaf = null; paint(el); });
  }
  function isStrip(n) { return n && n.nodeType === 1 && n.matches && n.matches(SEL); }
  document.addEventListener('scroll', function (e) { if (isStrip(e.target)) schedule(e.target); }, true);
  /* photos size themselves as they load; repaint the strip they sit in */
  document.addEventListener('load', function (e) {
    var t = e.target, s = t && t.nodeType === 1 && t.closest ? t.closest(SEL) : null;
    if (s) schedule(s);
  }, true);
  function all() { Array.prototype.forEach.call(document.querySelectorAll(SEL), paint); }
  window.addEventListener('resize', all);
  window.addEventListener('load', all);
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  new MutationObserver(function (muts) {
    for (var m = 0; m < muts.length; m++) {
      var added = muts[m].addedNodes;
      for (var a = 0; a < added.length; a++) {
        var n = added[a];
        if (n.nodeType !== 1) continue;
        if (isStrip(n)) schedule(n);
        else if (n.querySelector) { var q = n.querySelector(SEL); if (q) schedule(q); }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
